export default __webpack_public_path__ + "static/genre_01-0141662721b71495037b1574eb928d6e.png";